// import React, { useState } from "react";
// import "../assets/css/Cgt.css";

// const CgtManagement = () => {
//   const [formData, setFormData] = useState({
//     branch: "",
//     officer: "",
//     description: "",
//     startDate: "",
//     center: "",
//     group: "",
//   });

//   const [data, setData] = useState([
//     {
//       id: 1,
//       cgtId: "CGT001",
//       center: "Center A",
//       group: "Group X",
//       description: "Initial CGT session",
//       startDate: "2025-10-01",
//       officer: "Ravi Kumar",
//     },
//     {
//       id: 2,
//       cgtId: "CGT002",
//       center: "Center B",
//       group: "Group Y",
//       description: "Follow-up CGT",
//       startDate: "2025-10-03",
//       officer: "Anita Sharma",
//     },
//   ]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleAdd = () => {
//     if (!formData.branch || !formData.officer || !formData.center || !formData.group) {
//       alert("Please fill all required fields.");
//       return;
//     }

//     const newData = {
//       id: data.length + 1,
//       cgtId: `CGT00${data.length + 1}`,
//       center: formData.center,
//       group: formData.group,
//       description: formData.description,
//       startDate: formData.startDate,
//       officer: formData.officer,
//     };
//     setData([...data, newData]);
//     setFormData({
//       branch: "",
//       officer: "",
//       description: "",
//       startDate: "",
//       center: "",
//       group: "",
//     });
//   };

//   return (
//     <div className="CgtManagement-container">
//       {/* --- CGT Form Section --- */}
//       <div className="CgtManagement-form">
//         <div className="Cgtform-row">
//           <div className="Cgtform-group">
//             <label>Branch</label>
//             <select name="branch" value={formData.branch} onChange={handleChange}>
//               <option value="">Select Branch</option>
//               <option value="Branch A">Branch A</option>
//               <option value="Branch B">Branch B</option>
//             </select>
//           </div>
//           <div className="Cgtform-group">
//             <label>Wealth Officer</label>
//             <select name="officer" value={formData.officer} onChange={handleChange}>
//               <option value="">Select Officer</option>
//               <option value="Ravi Kumar">Ravi Kumar</option>
//               <option value="Anita Sharma">Anita Sharma</option>
//             </select>
//           </div>
//         </div>

//         <div className="Cgtform-row">
//           <div className="Cgtform-group">
//             <label>Description</label>
//             <input
//               type="text"
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               placeholder="Enter description"
//             />
//           </div>
//           <div className="Cgtform-group">
//             <label>CGT Start Date</label>
//             <input
//               type="date"
//               name="startDate"
//               value={formData.startDate}
//               onChange={handleChange}
//             />
//           </div>
//         </div>

//         <div className="Cgtform-row">
//           <div className="Cgtform-group">
//             <label>Center</label>
//             <input
//               type="text"
//               name="center"
//               value={formData.center}
//               onChange={handleChange}
//               placeholder="Enter Center"
//             />
//           </div>
//           <div className="Cgtform-group">
//             <label>Group</label>
//             <select name="group" value={formData.group} onChange={handleChange}>
//               <option value="">Select Group</option>
//               <option value="Group X">Group X</option>
//               <option value="Group Y">Group Y</option>
//             </select>
//           </div>
//         </div>

//         <div className="Cgtform-action">
//           <button onClick={handleAdd}>Add</button>
//         </div>
//       </div>

//       {/* --- CGT Table Section --- */}
//       <div className="CgtManagement-table-container">
//         <h3>CGT Details</h3>

//          <div className="Cgt-showingpage">

//         <div className="Cgttable-header">
//           <span>Showing Page 1 of 3</span>
//           <select>
//             <option>10</option>
//             <option>25</option>
//             <option>50</option>
//           </select>
//           <span>Result Per Page</span>
//           <div className="CgtManagement-searchbar">
//   <input
//     type="text"
//     placeholder="🔍 Search by CGT ID,Employee..."
//   />
//   <button className="Cgt-but">Search</button>
// </div>
//         </div>

//         </div>

//         <table className="CgtManagement-table">
//           <thead>
//             <tr>
//               <th>Sr. No.</th>
//               <th>CGT ID</th>
//               <th>Center Name</th>
//               <th>Group Name</th>
//               <th>Description</th>
//               <th>CGT Start Date</th>
//               <th>CGT Taken By</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((item, index) => (
//               <tr key={item.id}>
//                 <td>{index + 1}</td>
//                 <td>{item.cgtId}</td>
//                 <td>{item.center}</td>
//                 <td>{item.group}</td>
//                 <td>{item.description}</td>
//                 <td>{item.startDate}</td>
//                 <td>{item.officer}</td>
//                 <td>
//                   <button className="Cgtedit-btn">Edit</button>
//                   <button className="Cgtdelete-btn">Delete</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default CgtManagement;

// ----------------------------------------

import React, { useMemo, useState } from "react";
import "../assets/css/Cgt.css";
import { Edit, Trash } from "lucide-react";
import { toast } from "react-toastify";

const CgtManagement = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  const [loading,setLoading]=useState(false)
  const ITEMS_PER_PAGE_OPTIONS = [1, 2, 4];
  const [formData, setFormData] = useState({
    branch: "",
    officer: "",
    description: "",
    startDate: "",
    center: "",
    group: "",
  });

  const [data, setData] = useState([
    {
      id: 1,
      cgtId: "CGT001",
      center: "Center A",
      group: "Group X",
      description: "Initial CGT session",
      startDate: "2025-10-01",
      officer: "Ravi Kumar",
    },
    {
      id: 2,
      cgtId: "CGT002",
      center: "Center B",
      group: "Group Y",
      description: "Follow-up CGT",
      startDate: "2025-10-03",
      officer: "Anita Sharma",
    },
  ]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    if (
      !formData.branch ||
      !formData.officer ||
      !formData.center ||
      !formData.group
    ) {
      toast.warn("Please fill all required fields.");
      return;
    }

    const newData = {
      id: data.length + 1,
      cgtId: `CGT00${data.length + 1}`,
      center: formData.center,
      group: formData.group,
      description: formData.description,
      startDate: formData.startDate,
      officer: formData.officer,
    };
    setData([...data, newData]);
    setFormData({
      branch: "",
      officer: "",
      description: "",
      startDate: "",
      center: "",
      group: "",
    });
  };

  // Search + Pagination
  const filteredData = useMemo(() => {
    return data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [data, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div className="group-cgt-container">
      <h1 className="group-cgt-heading">Group CGT</h1>

      {/* ================= FORM ================= */}
      <section className="group-cgt-top">
        <form className="group-cgt-form" onSubmit={handleAdd}>
          <div className="group-cgt-form-section">
            <div className="group-cgt-form-input-fields">
              <label>Branch</label>
              <select
                name="branch"
                value={formData.branch}
                onChange={handleChange}
              >
                <option value="">Select Branch</option>
                <option value="Branch A">Branch A</option>
                <option value="Branch B">Branch B</option>
              </select>
            </div>

            <div className="group-cgt-form-input-fields">
              <label>Wealth Officer</label>
              <select
                name="officer"
                value={formData.officer}
                onChange={handleChange}
              >
                <option value="">Select Officer</option>
                <option value="Ravi Kumar">Ravi Kumar</option>
                <option value="Anita Sharma">Anita Sharma</option>
              </select>
            </div>

            <div className="group-cgt-form-input-fields">
              <label>Description</label>
             <input
               type="text"
               name="description"
               value={formData.description}
               onChange={handleChange}
               placeholder="Enter description"
             />
            </div>

            <div className="group-cgt-form-input-fields">
              <label>CGT Start Date</label>
             <input
               type="date"
               name="startDate"
               value={formData.startDate}
               onChange={handleChange}
             />
            </div>

            <div className="group-cgt-form-input-fields">
              <label>Center</label>
             <input
               type="text"
               name="center"
               value={formData.center}
               onChange={handleChange}
               placeholder="Enter Center"
             />
            </div>

            <div className="group-cgt-form-input-fields">
              <label>Group</label>
            <select name="group" value={formData.group} onChange={handleChange}>
              <option value="">Select Group</option>
              <option value="Group X">Group X</option>
              <option value="Group Y">Group Y</option>
            </select>
            </div>
          </div>

          <div className="group-cgt-form-submit-btn">
             <button>Add</button>
          </div>
        </form>
      </section>

      {/* ================= REPORT SECTION ================= */}
      <div className="group-cgt-report-container">
        <h1>CGT Details</h1>
        <div className="group-cgt-report-filter-div">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <div className="group-cgt-filter">
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="group-cgt-report-table-container">
          <table className="group-cgt-report-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
               <th>CGT ID</th>
               <th>Center Name</th>
               <th>Group Name</th>
               <th>Description</th>
               <th>CGT Start Date</th>
               <th>CGT Taken By</th>
               <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.cgtId}</td>
                 <td>{item.center}</td>
                 <td>{item.group}</td>
                 <td>{item.description}</td>
                 <td>{item.startDate}</td>
                 <td>{item.officer}</td>
                <td className="group-action-btns">
                      <Edit
                        className="edit-icon"
                      />
                      <Trash
                        className="delete-icon"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  {loading ? (
                    <td colSpan="11" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  ) : (
                    <td colSpan="11" style={{ textAlign: "center" }}>
                      No results found
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredData.length > itemsPerPage && (
          <div className="group-cgt-pagination-div">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ⬅ Prev
            </button>

            <span>
              {" "}
              Page {currentPage} of {totalPages}{" "}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next ➡
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CgtManagement;
